import { FC, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import { Loader, PageLoader } from '../loaders';
import { useUser } from '../../lib';
import { AppRoutes } from '../../routes';

const GameLoader = () => <Loader bgColor="#f0f4f7" />;

type SuspenseFallbackProps = {};

export const LayoutSuspense: FC<SuspenseFallbackProps> = ({ children }) => {
  const { ready } = useTranslation(void 0, { useSuspense: false });
  const { user } = useUser();
  const pathname = window.location.pathname;

  if (
    AppRoutes.EMBED.match(pathname) ||
    AppRoutes.USER_WIDGET.match(pathname) ||
    AppRoutes.USER_WIDGET_WIX.match(pathname) ||
    !ready ||
    !user
  ) {
    return <Suspense fallback={<GameLoader />}>{children}</Suspense>;
  }

  return (
    <Suspense
      fallback={
        <BrowserRouter>
          <PageLoader />
        </BrowserRouter>
      }
    >
      {children}
    </Suspense>
  );
};
